import React from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

export default function dialogSoundDelete(props) {
  const file = _.get(props, "soundToDelete.file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(props, "soundToDelete.name") || file;
  const assetName = baseName && !baseName.includes(".") ? baseName + ext : baseName;

  const handleDelete = (progressID) => {
    return fetch(getServerUri("sound/deleteOne"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        soundID: props.soundToDelete._id,
        fileName: _.get(props.soundToDelete, "file"),
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        let newSounds = _.cloneDeep(props.sounds);
        newSounds.splice(
          newSounds.indexOf(newSounds.filter((sound) => sound._id === props.soundToDelete._id)[0]),
          1
        );
        props.deleteSoundFromSounds(props.soundToDelete._id);
        props.setSounds(newSounds);
        if (newSounds.length > 0) {
          if (props.soundToDelete._id === props.selectedSoundID) props.selectSound(newSounds[0]._id);
        } else props.selectSound("");
        props.createSnackbar("Sound deleted", "success");
        props.onAfterDelete?.();
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetName={assetName}
      assetID={_.get(props, "soundToDelete._id")}
      assetFile={_.get(props, "soundToDelete.file")}
      assetType="sound"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the sound."
    />
  );
}
